// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"df6b3e964fbbd5e4","5763":"a0b4499271eee1f2","7222":"18c35824e7214f89","7937":"f21c520b3cc0f76d"}[chunkId] + ".js";
};